import request from '../untils/request';

export const shopOrderApi = params => {
  return request({
    url: '/shop/shop-order/index',
    authCode: 'SHOP-ORDER_INDEX',
    params,
  });
};

export const shopaAddWhiteListApi = params => {
  return request({
    url: '/shop/shop/add-white-list',
    authCode: 'SHOP_ADD-WHITE-LIST',
    params,
  });
};

export const shopaDelWhiteListApi = params => {
  return request({
    url: '/shop/shop/del-white-list',
    authCode: 'SHOP_DEL-WHITE-LIST',
    params,
  });
};

export const shopaListApi = params => {
  return request({
    url: '/shop/shop/index',
    authCode: 'SHOP_INDEX',
    params,
  });
};

export const transferChildApi = params => {
  return request({
    url: '/shop/shop/transfer',
    authCode: 'SHOP_TRANSFER',
    params,
  });
};

export const transferOutApi = params => {
  return request({
    url: '/shop/shop/transfer-out',
    authCode: 'SHOP_TRANSFER-OUT',
    params,
  });
};

export const subordinateApi = params => {
  return request({
    url: '/shop/shop/subordinate',
    authCode: 'SHOP_SUBORDINATE',
    params,
  });
};

export const channelApi = params => {
  return request({
    url: '/shop/shop/get-channel',
    authCode: 'SHOP_INDEX',
    params,
  });
};

export const shopLevelApi = params => {
  return request({
    url: '/shop/shop/get-shop-level',
    authCode: 'SHOP_CHANGE-LEVEL',
    params,
  });
};

export const changeLevelApi = params => {
  return request({
    url: '/shop/shop/change-level',
    authCode: 'SHOP_CHANGE-LEVEL',
    params,
  });
};

export const shopDeleteApi = params => {
  return request({
    url: '/shop/shop/delete',
    authCode: 'SHOP_DELETE',
    params,
  });
};

export const blackShopApi = params => {
  return request({
    url: '/shop/shop/add-black-list',
    authCode: 'SHOP_ADD-BLACK-LIST',
    params,
  });
};

export const modifyPhoneApi = params => {
  return request({
    url: '/shop/shop/modify-phone',
    authCode: 'SHOP_MODIFY-PHONE',
    params,
  });
};

export const inviteNumApi = params => {
  return request({
    url: '/shop/shop/invite-num',
    authCode: 'SHOP_INVITE-NUM',
    params,
  });
};

export const addRemarkApi = params => {
  return request({
    url: '/shop/shop/add-remark',
    authCode: 'SHOP_ADD-REMARK',
    params,
  });
};

export const inviteSwitchApi = params => {
  return request({
    url: '/shop/shop/invite-switch',
    authCode: 'SHOP_INVITE-SWITCH',
    params,
  });
};

export const restoreApi = params => {
  return request({
    url: '/shop/shop/restore',
    authCode: 'SHOP_RESTORE',
    params,
  });
};

export const cancelApplyApi = params => {
  return request({
    url: '/shop/shop/cancel',
    authCode: 'SHOP_CANCEL',
    params,
  });
};

export const removeBlackApi = params => {
  return request({
    url: '/shop/shop/remove-blacklist',
    authCode: 'SHOP_REMOVE-BLACKLIST',
    params,
  });
};

export const blackImgApi = params => {
  return request({
    url: '/shop/shop/black-images',
    authCode: '/shop/shop/black-images',
    params,
  });
};

export const inviteOpenApi = params => {
  return request({
    url: '/shop/shop/invite-open',
    authCode: 'SHOP_INVITE-OPEN',
    params,
  });
};

export const memberSubListApi = params => {
  return request({
    url: '/shop/shop/member-sub-list',
    authCode: 'SHOP_MEMBER-SUB-LIST',
    params,
  });
};

export const updateSubMemerApi = params => {
  return request({
    url: '/member/member-sub/update',
    authCode: 'MEMBER-SUB_UPDATE',
    params,
  });
};

export const getCheckedPurviewApi = params => {
  return request({
    url: '/member/member-sub/get-checked-purview',
    authCode: 'MEMBER-SUB_PURVIEW',
    params,
  });
};

export const editePurviewApi = params => {
  return request({
    url: '/member/member-sub/purview',
    authCode: 'MEMBER-SUB_PURVIEW',
    params,
  });
};

export const deleteSubMemberApi = params => {
  return request({
    url: '/member/member-sub/delete',
    authCode: 'MEMBER-SUB_DELETE',
    params,
  });
};

export const shopGoodsListApi = params => {
  return request({
    url: '/shop/shop/shop-goods',
    authCode: 'SHOP_INDEX',
    params,
  });
};

export const skuListApi = params => {
  return request({
    url: '/shop/shop/sku-list',
    authCode: 'SHOP_INDEX',
    params,
  });
};

export const shopProfitApi = params => {
  return request({
    url: '/shop/shop/profit',
    authCode: 'SHOP_PROFIT',
    params,
  });
};

export const shopTotalProfitApi = params => {
  return request({
    url: '/shop/shop/total-profit',
    authCode: 'SHOP_PROFIT',
    params,
  });
};

export const shopFeatureApi = params => {
  return request({
    url: '/shop/feature/index',
    authCode: 'FEATURE_INDEX',
    params,
  });
};

export const shopFeatureDetailApi = params => {
  return request({
    url: '/shop/feature/detail',
    authCode: 'FEATURE_INDEX',
    params,
  });
};

export const shopFeatureUpdateApi = params => {
  return request({
    url: '/shop/feature/update',
    authCode: 'FEATURE_INDEX',
    params,
  });
};

export const memberLevelApi = params => {
  return request({
    url: '/shop/member-level/index',
    authCode: 'MEMBER-LEVEL_INDEX',
    params,
  });
};

export const memberLevelDetailApi = params => {
  return request({
    url: '/shop/member-level/detail',
    authCode: 'MEMBER-LEVEL_INDEX',
    params,
  });
};

export const memberLevelUpdateApi = params => {
  return request({
    url: '/shop/member-level/update',
    authCode: '',
    params,
  });
};

export const shopUpdateApi = params => {
  return request({
    url: '/shop/shop-upgrade/index',
    authCode: 'MEMBER-LEVEL_INDEX',
    params,
  });
};
export const shopUpdateInfoApi = params => {
  return request({
    url: '/shop/shop-upgrade/upgrade-info',
    authCode: 'SHOP-UPGRADE_INDEX',
    params,
  });
};

export const shopUpdateLevelApi = params => {
  return request({
    url: '/shop/shop-upgrade/up-shop-level',
    authCode: 'SHOP-UPGRADE_INDEX',
    params,
  });
};

export const shopUpdateLevelPApi = params => {
  return request({
    url: '/shop/shop-upgrade/level-p',
    authCode: 'SHOP-UPGRADE_INDEX',
    params,
  });
};

export const shopFeatureOrderApi = params => {
  return request({
    url: '/shop/feature-order/index',
    authCode: '',
    params,
  });
};

export const shopFeatureOrderdetailApi = params => {
  return request({
    url: '/shop/feature-order/detail',
    authCode: 'FEATURE-ORDER_INDEX',
    params,
  });
};

export const shopFeatureOrderSendApi = params => {
  return request({
    url: '/shop/feature-order/send',
    authCode: 'FEATURE-ORDER_DETAIL',
    params,
  });
};

export const shopFeatureOrderRefundApi = params => {
  return request({
    url: '/shop/feature-order/refund',
    authCode: 'FEATURE-ORDER_REFUND',
    params,
  });
};

export const memberSubCreateApi = params => {
  return request({
    url: '/member/member-sub/create',
    authCode: 'FEATURE-ORDER_REFUND',
    params,
  });
};

export const getAuthInfoApi = params => {
  return request({
    url: '/shop/shop/auth-info',
    authCode: 'SHOP_AUTH',
    params,
  });
};

export const createAuthInfoApi = params => {
  return request({
    url: '/shop/shop/auth',
    authCode: 'SHOP_AUTH',
    params,
  });
};

export const getRemarksApi = params => {
  return request({
    url: '/shop/shop/get-remarks',
    authCode: 'SHOP_ADD-REMARK',
    params,
  });
};

export const delayAuthListApi = params => {
  return request({
    url: '/shop/shop/delay-auth-list',
    authCode: 'SHOP_INDEX',
    params,
  });
};

export const delayAuthApi = params => {
  return request({
    url: '/shop/shop/delay-auth',
    params,
  });
};

export const allAdrressWithChilren = params => {
  return request({
    url: '/shop/shop/area-list',
    params,
  });
};